
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14","cy":"14","r":"14","transform":"rotate(-90 14 14)","fill":"#F5F6F8"}}),_c('circle',{attrs:{"cx":"9.5","cy":"13.5","r":"1.5","transform":"rotate(-90 9.5 13.5)","fill":"#000"}}),_c('circle',{attrs:{"cx":"14.5","cy":"13.5","r":"1.5","transform":"rotate(-90 14.5 13.5)","fill":"#000"}}),_c('circle',{attrs:{"cx":"19.5","cy":"13.5","r":"1.5","transform":"rotate(-90 19.5 13.5)","fill":"#000"}})])
          )
        }
      }
    